import { render, staticRenderFns } from "./ABMTalonarios.vue?vue&type=template&id=394b1b82"
import script from "./ABMTalonarios.vue?vue&type=script&lang=js"
export * from "./ABMTalonarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports